/** beancount.io docs page on declaring `cash-flow-role` on `open` directives. */
export const CASH_FLOW_ROLES_DOC_PATH = "cash-flow-roles";
